/*
 * @Descripttion:调用支付接口的函数
 * @Author: congz
 * @Date: 2020-06-10 19:03:02
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 17:51:36
 */

import axios from 'axios'

// 初始化支付信息
const initPayment = form =>
  axios.post('/api/v1/payments', form).then(res => res.data)

// 初始化在线支付 (DeepPay)
const initOnlinePayment = form =>
  axios.post('/api/v1/payment/init', form).then(res => res.data)

// 查询订单支付状态
const queryOrderStatus = orderNum =>
  axios.get(`/api/v1/orders/${orderNum}`).then(res => res.data)

export { initPayment, initOnlinePayment, queryOrderStatus }
